import { isEmpty } from 'lodash'
import { crmServiceUrl, engineServiceUrl } from '../utils/constants'
import { API } from './index'

export const getCRMAuth = (crmId: string) =>
  API.get(`${crmServiceUrl}/crms/${crmId}?includes=creds,crm_app_creds`)

export const getCRMType = (crmId: string) =>
  API.get(`${crmServiceUrl}/crms/${crmId}`)

export const fetchCRMs = () => API.get(`${crmServiceUrl}/auth_defintions`)

export const postCRMAuthData = (authData: unknown, partnerId: string) =>
  API.post(`${engineServiceUrl}/partners/${partnerId}/crms`, authData, {
    params: {
      check_connection: true,
    },
  })

export const patchCRMAuthData = (crmId: string, authData: unknown) =>
  API.patch(`${crmServiceUrl}/crms/${crmId}`, authData, {
    params: {
      check_connection: true,
    },
  })

export function putAppMappings(
  partnerId: string,
  CRMInfo: { crm_type: string; update_status: boolean }
) {
  API.put(`${engineServiceUrl}/partners/${partnerId}/app_mappings`, CRMInfo)
}

export const patchCRMSchema = (
  crmId: string,
  crmSchema: Record<string, unknown>
) => API.patch(`${crmServiceUrl}/crms/${crmId}`, { crm_schema: crmSchema })

export const deleteCRMFromCRMService = (crmId: string) =>
  API.delete(`${crmServiceUrl}/crms/${crmId}`)

export const getCheckCrmConnection = (partnerId: string, crmId: string) =>
  API.get(
    `${crmServiceUrl}/partners/${partnerId}/crms/${crmId}/connection-status`
  )

export type FetchAutomationStatusOptions =
  | { labraAuthProvider: 'labra' }
  | { labraAuthProvider: 'salesforce'; signedRequest: string }

export const fetchAutomationStatusAndAccess = (
  crmId: string,
  options: FetchAutomationStatusOptions
) => {
  if (!crmId || isEmpty(crmId)) {
    throw new Error('CrmId is required')
  }
  const provider = options.labraAuthProvider
  if (provider === 'salesforce') {
    if (!options.signedRequest || isEmpty(options.signedRequest)) {
      throw new Error('signed_request is required')
    }
  }
  const body =
    provider === 'salesforce' ? { signed_request: options.signedRequest } : {}
  return API.post(
    `${crmServiceUrl}/crms/${crmId}/salesforce/event-bridge/status`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-labra-auth-provider': provider,
      },
    }
  )
}
